<template>
    <div
        class="cms-content-column cms-content-our-range__no-special-offer cms-content-our-range__container"
        :class="{'cms-content-our-range__container--hidden' : (hideResults && index >= 3 )}"
    >
        <a
            :href="vehicle.route"
            v-on:click="(event) => {
                event.preventDefault();
                analyticsEvent({
                    category: 'New Model Search',
                    label: 'Car Image',
                    action: `Clicked`,
                }, event);
            }"
        >
            <picture class="cms-content-our-range__image">
                <source :srcset="vehicle.image_webp" type="image/webp" />
                <img
                    :src="vehicle.image"
                    :alt="vehicle.short_name"
                    class="cms-content-our-range__image"
                />
            </picture>
        </a>
        <div class="rd-card cms-content-our-range__card">
            <h2 class="cms-content-slice__trim-name">
                {{ vehicle.model_title }}
            </h2>
            <div class="cms-content-our-range__finance-wrapper">
                <div class="cms-content-our-range__flex-row cms-content-our-range-coming-soon__title">
                    <p>Latest vehicle from {{ vehicle.brand_name }}</p>
                </div>
                <div class="cms-content-our-range__flex-row cms-content-our-range-coming-soon__dealer">
                    <p>Coming soon to your local Stellantis &You {{ vehicle.brand_name }} dealership.</p>
                </div>
            </div>
            <a
                class="btn btn--primary btn--full-width cms-content-our-range__offers-button"
                :href="vehicle.route"
                v-on:click="(event) => {
                    event.preventDefault();
                    analyticsEvent({
                        category: 'New Model Search',
                        label: 'View More CTA',
                        action: `Clicked`,
                    }, event);
                }"
            >
                View More
            </a>
            <div class="cms-content-our-range__test-drive-button cms-content-our-range__test-drive-button--placeholder"></div>
        </div>
    </div>
</template>

<script>
import { customEvent } from "../../../modules/tracking/AnalyticsEvents";
import { MatchHeight } from "js-match-height";

export default {
    props: {
        vehicle: Object,
        index: Number,
        hideResults: false
    },
    mounted() {
        new MatchHeight(".cms-content-our-range__card .cms-content-slice__trim-name");
    },
    methods: {
        customEvent,
        analyticsEvent({ category, action, label }, event = null) {
            customEvent({
                category: category,
                action: action,
                label: label
            });

            window.location = this.navigateToTarget(event.target);
        },
        navigateToTarget(target, depth = 0) {
            if (depth > 5) {
                return;
            }

            if (target.tagName === 'A') {
                return target.href;
            }

            return this.navigateToTarget(target.parentElement, depth + 1);
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/our-range/VehicleComingSoon.vue